import { render } from "./QuickpaySettingsPaymentPartnersLoader.vue?vue&type=template&id=119d1f40&scoped=true"
const script = {}

import "./QuickpaySettingsPaymentPartnersLoader.vue?vue&type=style&index=0&id=119d1f40&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119d1f40"]])

export default __exports__